import { create } from 'zustand';
import { Client, Plan } from '../models/core';

interface ClientState {
	client?: Client;
	plans?: Plan[];
	clientId?: string;
	setClient: (client: Client|undefined) => void;
	setPlans: (plans: Plan[]) => void;
}

export const useClientStore = create<ClientState>((set) => ({
	client: undefined,
	plans: undefined,
	clientId: undefined,
	setClient: (client:Client|undefined) =>
		set((state) => ({
			client,
			clientId: client?._id,
			plans: state.client?._id !== client?._id ? undefined : state.plans,
		})),
	setPlans: (plans) => set({ plans }),
}));